import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import { Recommend } from 'src/common/recommend/Recommend';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './TransactionSuccess.less';

export default class TransactionSuccess extends OfficialPage {
  state = {
    storeStyle: {}
  }
  orderId = ''

  recommendRef = React.createRef();

  constructor(props) {
    super(props);
    document.title = '交易成功';
  }

  componentDidMount(options = getCurrentPageQueryParams()) {
    if (options.pageFrom != 'transation') {
      app.setPageTitle('评价成功')
    }
    this.orderId = options.orderId
    this.setData({
      franchiseeId: options.franchiseeId || '',
      pageFrom: options.pageFrom
    })
  }

  componentDidMount() {
    this.getAppECStoreConfig()
  }

  goToHomepage = () => {
    let router = app.getHomepageRouter()
    app.reLaunch({
      url: '/pages/' + router + '/' + router
    })
  }
  goToComment = () => {
    app.turnToPage(
      '/eCommerce/pages/makeComment/makeComment?detail=' +
      this.orderId +
      '&franchisee=' +
      this.data.franchiseeId,
      1
    )
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config,
        hasRecommendConfig: res.recommend_config ? true : false
      })
    }, this.data.franchiseeId)
  }

  render() {
    const {
      showGetUserInfo,
      storeStyle,
      pageFrom,
      hasRecommendConfig,
      franchiseeId
    } = this.state
    return (
      <div className="official-page transaction-success">
        <TopNav title="交易成功"/>
        {hasRecommendConfig ? (
          <div
            className="success-box"
            style={convertLineStyleData('background:' + storeStyle.theme)}
          >
            <div className="title">
              <img
                className="goods-complete-succes"
                src="http://develop.zhichiwangluo.com/static/webapp/images/xcx-goods/goods-complete-success.png"
              />
              <span>{pageFrom == 'transation' ? '交易成功' : '评价成功'}</span>
            </div>
            <div className="slogan">
              {pageFrom == 'transation'
                ? '去评价一下这次的购物体验吧~'
                : '再去逛逛店铺吧~'}
            </div>
            <div className="btn-area">
              {pageFrom == 'transation' && (
                <div onClick={this.goToComment}>立即评价</div>
              )}
              <div onClick={this.goToHomepage}>返回首页</div>
            </div>
            <img
              className="goods-complete-bg"
              src="http://develop.zhichiwangluo.com/static/webapp/images/xcx-goods/goods-complete-bg.png"
            />
          </div>
        ) : (
            <React.Fragment>
              <div className="no-recommend-box">
                <div
                  className="success-box"
                  style={convertLineStyleData('background:' + storeStyle.theme)}
                >
                  <div className="title">
                    <img
                      className="goods-complete-succes"
                      src="http://develop.zhichiwangluo.com/static/webapp/images/xcx-goods/big-goods-complete-success.png"
                    />
                  </div>
                  <img
                    className="goods-complete-bg"
                    src="http://develop.zhichiwangluo.com/static/webapp/images/xcx-goods/goods-complete-bg.png"
                  />
                </div>
                <div
                  className="goods-complete-title"
                  style={convertLineStyleData('color:' + storeStyle.theme)}
                >
                  {pageFrom == 'transation' ? '交易成功' : '评价成功'}
                </div>
                <div className="slogan">
                  {pageFrom == 'transation'
                    ? '去评价一下这次的购物体验吧~'
                    : '再去逛逛店铺吧~'}
                </div>
                <div className="btn-area">
                  {pageFrom == 'transation' && (
                    <div
                      className="go-comment"
                      style={convertLineStyleData(
                        'color:' +
                        storeStyle.theme +
                        ';border-color:' +
                        storeStyle.theme
                      )}
                      onClick={this.goToComment}
                    >
                      立即评价
                  </div>
                  )}
                  <div
                    className={
                      pageFrom == 'transation' ? '' : 'comment-back-homepage'
                    }
                    style={convertLineStyleData(
                      'color:' +
                      storeStyle.theme +
                      ';border-color:' +
                      storeStyle.theme
                    )}
                    onClick={this.goToHomepage}
                  >
                    返回首页
                </div>
                </div>
              </div>
            </React.Fragment>
          )}
        <Recommend id="component-recommend" franchiseeId={franchiseeId} ref={this.recommendRef} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/transaction-success/TransactionSuccess.jsx